/**
 * GDSCardSelectionStepRenderer.js
 * Renders the UI for the card selection step (Step 3).
 */
export class GDSCardSelectionStepRenderer {
    constructor(orchestrator) {
        this.orchestrator = orchestrator;
        this.builder = orchestrator.getBuilder();
        this.cardManager = this.builder.cardManager;
    }

    /**
     * Renders the entire step 3 view.
     */
    async render() {
        // Delegate the entire rendering process to the Card Manager
        await this.cardManager.renderCardSelectionStep();
    }

    /**
     * Defines the configuration for the main action button in this step.
     */
    getButtonConfig() {
        // Step 3 does not have a "Next" button, so it should be hidden.
        // "Add to Cart" is handled separately in the header.
        return {
            innerHTML: '',
            isVisible: false,
            isEnabled: false,
        };
    }

    /**
     * Step 3 does not collect form data in the same way as steps 1-2.
     */
    collectFormData() {
        return {}; // No data to collect from a form submit button
    }
}
